var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Real-Time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Real-Time",
    stroke: "#B5B5B5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.038220, 2.797436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3374158,8.07787858 C13.9244896,5.48345518 11.6728729,3.50452562 8.96158358,3.50452562 C6.25029427,3.50452562 3.99867756,5.48345518 3.57796025,8.07787858",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.96178019,
    cy: 9.15149566,
    r: 1.3530739
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9235604,8.1024314 C17.465241,3.55197498 13.6268165,0 8.96178019,0 C4.29674393,0 0.458319352,3.55197498 0,8.1024314",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.96178019,
    y1: 10.5045696,
    x2: 8.95701171,
    y2: 14.4990973,
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    transform: "translate(8.961780, 17.547465) rotate(45.000000) translate(-8.961780, -17.547465) ",
    points: "6.8062586 19.7029867 6.8062586 15.3919435 11.1173018 15.3919435"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTime);
export default __webpack_public_path__ + "static/media/Real-Time.88f1241a.svg";
export { ForwardRef as ReactComponent };